import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { IconButton, Tooltip } from '@mui/material'
import PersonOutline from '@mui/icons-material/PersonOutline'
import LogoutIcon from '@mui/icons-material/Logout'
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications'

import { UserProfileDialog, UserLogoutDialog, UserRightsDialog } from '../../../containers'
import { Logger, LoggerTypes } from '../../../utils'
import { colorTypes, userRightTypes } from '../../../constants'
import { AccessControl } from '../../AccessControl'
import './style.scss'

/**
 * Display the right Icon menu section.
 *
 * @param {object} currentProject Current project object.
 * @param {object} currentScenario Current scenario object.
 * @returns {div}
 */
// eslint-disable-next-line no-unused-vars
export const HeaderRight = ({ currentProject, currentScenario }) => {
  const { t } = useTranslation()

  const [openUserProfileDialog, setOpenUserProfileDialog] = useState(false)
  const [openUserLogoutDialog, setOpenUserLogoutDialog] = useState(false)
  const [openUserRightsDialog, setOpenUserRightsDialog] = useState(false)

  const onUserProfileClick = (e) => {
    e.stopPropagation()
    Logger.trace(LoggerTypes.CONTROLLER, 'HeaderRight.onUserProfileClick()', { openUserProfileDialog })
    setOpenUserProfileDialog(!openUserProfileDialog)
  }

  const onUserLogoutClick = (e) => {
    e.stopPropagation()
    Logger.trace(LoggerTypes.CONTROLLER, 'HeaderRight.onUserLogoutClick()', { openUserLogoutDialog })
    setOpenUserLogoutDialog(!openUserLogoutDialog)
  }

  const onUserRightsClick = (e) => {
    e.stopPropagation()
    Logger.trace(LoggerTypes.CONTROLLER, 'HeaderRight.onUserRightsClick()', { openUserRightsDialog })
    setOpenUserRightsDialog(!openUserRightsDialog)
  }

  // Logger.trace(LoggerTypes.CONTAINER, 'HeaderRight.render()', {
  //   openUserProfileDialog,
  //   openUserInfoDialog,
  //   openUserLogoutDialog
  // })

  return (
    <div className="HeaderRight">
      {/* -- Profile -- */}
      <Tooltip title={t('users.profile.title')}>
        <IconButton aria-label="Profile" onClick={onUserProfileClick}>
          <PersonOutline color={colorTypes.PRIMARY} size="small" edge="start" />
        </IconButton>
      </Tooltip>
      {openUserProfileDialog && (
        <UserProfileDialog className="HeaderRightDialog" setOpenDialog={setOpenUserProfileDialog} />
      )}

      {/* -- Users Rights - Roles -- */}
      <AccessControl userPermissions={[userRightTypes.USER_RIGHTS_EDIT]} renderNoAccess={() => <></>}>
        <>
          <Tooltip title={t('users.rights.title')}>
            <IconButton aria-label="Settings" onClick={onUserRightsClick}>
              <SettingsApplicationsIcon color={colorTypes.PRIMARY} size="small" />
            </IconButton>
          </Tooltip>
          {openUserRightsDialog && (
            <UserRightsDialog className="HeaderRightDialog" setOpenDialog={setOpenUserRightsDialog} />
          )}
        </>
      </AccessControl>

      {/* -- Logout -- */}
      <Tooltip title={t('users.signout.title')}>
        <IconButton aria-label="Profile" onClick={onUserLogoutClick}>
          <LogoutIcon color={colorTypes.PRIMARY} size="small" edge="start" />
        </IconButton>
      </Tooltip>
      {openUserLogoutDialog && (
        <UserLogoutDialog className="HeaderRightDialog" setOpenDialog={setOpenUserLogoutDialog} />
      )}
    </div>
  )
}

HeaderRight.displayName = 'HeaderRight'

HeaderRight.propTypes = {
  currentProject: PropTypes.object,
  currentScenario: PropTypes.object
}

HeaderRight.defaultProps = {
  currentProject: null,
  currentScenario: null
}
